import { api } from './client';
import type { LoginRequest, RegisterRequest, AuthResponse } from '@/lib/types/auth';
import type { Audience } from '@/lib/types/audience';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post('/auth/login', credentials);
    const authResponse: AuthResponse = {
      user: response.user,
      accessToken: response.access_token
    };
    if (authResponse.accessToken) {
      api.setToken(authResponse.accessToken);
    }
    return authResponse;
  },

  register: async (userData: RegisterRequest): Promise<AuthResponse> => {
    const response = await api.post('/auth/register', userData);
    const authResponse: AuthResponse = {
      user: response.user,
      accessToken: response.access_token
    };
    if (authResponse.accessToken) {
      api.setToken(authResponse.accessToken);
    }
    return authResponse;
  },

  logout: async (): Promise<void> => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout request failed:', error);
    } finally {
      // Always clear the local token
      api.setToken(null);
    }
  },

  forgotPassword: async (nickname: string): Promise<{ message: string }> => {
    return await api.post('/auth/forgot-password', { nickname });
  },

  resetPassword: async (
    token: string,
    newPassword: string,
  ): Promise<{ message: string }> => {
    return await api.post('/auth/reset-password', { token, newPassword });
  },

  updateAudience: async (audience: Audience): Promise<{ message: string; audience: Audience }> => {
    const response = await api.patch('/auth/audience', { audience });
    return response;
  },

  getAudienceUser: async (): Promise<{ user: { id: string; nickname: string; gender: string; audience: Audience | null } }> => {
    const response = await api.get('/auth/hasaudience');
    return response;
  },
};
